import axios from '@plugins/axios';

class ReporteService {
    VentaPorDivisa(params = {}, options = {}) {
        return axios({
            url: `institution/reporte/divisa`,
            method: 'GET',
            params,
            ...options
        });
    }

    VentaPorJuego(params = {}, options = {}) {
        return axios({
            url: `institution/reporte/juego`,
            method: 'GET',
            params,
            ...options
        });
    }

    VentaPorSorteo(params = {}, options = {}) {
        return axios({
            url: `institution/reporte/sorteo`,
            method: 'GET',
            params,
            ...options
        });
    }
}

export const BaseReporteService = ReporteService

export default new ReporteService();